import{ FC, useEffect, Card, Button} from 'external/react'
import useParent from 'context/parent-context/hook'
import useFormValidation, { validators } from 'utilities/form-validation'
import UserProfileForm from './UserProfileForm'
import { notifyError, notifySuccess } from 'components/Notify'
import UpdatePasswordModal from './UpdatePassword'
import { createEmailValidation } from 'utilities/form-validation/validators'

const {createRequiredFieldValidation} = validators

const userProfileValidations = {
	email: [createRequiredFieldValidation('email'), createEmailValidation('email')],
	first_name: [createRequiredFieldValidation('first_name')],
	last_name: [createRequiredFieldValidation('last_name')]
}

const UserProfileModal: FC = () => {

	const {update, state: { userProfile}, updateProfile} = useParent()
	
	const [errors, validate] = useFormValidation(userProfileValidations);

	async function handleProfileSave() {
		if (!validate(userProfile, true)) return
		const response = await updateProfile(userProfile)
		const {data: updated, statusResponse: {message}} = response.data
		if (updated) notifySuccess(message)
		else notifyError(message)
	}

	function handleOpenChangePassword() {
		update({modals: {updatePassword: {open: {$set: true}}}})
	}

	useEffect(() => { validate(userProfile, false) }, [userProfile])

	return (
		<>
			<Card.Body>
					<UserProfileForm errors={errors}/>
					<Button variant='secondary' className='mt-2 mr-0 px-4' onClick={handleOpenChangePassword}>Cambiar contraseña</Button>
					<UpdatePasswordModal />
			</Card.Body>
			<Card.Footer className='d-flex justify-content-end px-0'>
				<Button variant='primary' className='mt-2 mr-0 px-4' onClick={handleProfileSave} >Guardar</Button>
			</Card.Footer>
		</>
	)

}


export {UserProfileModal as default}